import { NgModule } from '@angular/core';
import { ClickOutsiteDirective } from './dropdown.directive';
import { CommonModule } from '@angular/common';
@NgModule({
  declarations: [ClickOutsiteDirective],
  imports: [CommonModule],
  exports: [ClickOutsiteDirective]
})
export class MainDropdown {}
